<template>
  <div id="web">
    <div class="left">
      <side-menu />
    </div>
    <div class="right">
      <div class="top">
        <home-header />
      </div>
      <div class="rest">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from '@/components/SideNav.vue'
import HomeHeader from '@/components/HomeHeader.vue'

export default {
  name: 'WebSite',
  components: {
    SideMenu,
    HomeHeader
  }
}
</script>

<style scoped lang="scss">
@import 'src/assets/styles/common.scss';

#web {
  background-color: $global-background-color;
  width: 100%;
  height: 100vh;

  @extend .f-r;

  .left {
    height: 100%;
  }

  .right {
    overflow-x: hidden;
    flex-grow: 1;
    height: 100%;

    @extend .f-c;

    .rest {
      width: 100%;
      flex-grow: 1;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
